<template>
  <Fragment>
    <v-row style="margin-top: 30px; padding: 10px">
      <v-slider
        v-model.lazy="thresholdScore"
        label="Threshold"
        prepend-icon="mdi-script-text"
        :min="0"

        :max="85"
        :step="1"
        thumb-label="always"
      />

      <v-slider
        v-model.lazy="limit"
        label="Limit"
        prepend-icon="mdi-filter-check-outline"
        :min="5"
        :max="100"
        :step="10"
        thumb-label="always"
      />
    </v-row>
    <v-data-table
      group-by="group"
      sort-by="score"
      sort-desc
      :headers="headers"
      :items-per-page="leastPerformers?leastPerformers.length:10"
      dense
      item-key="mateId"
      :items="leastPerformers"
    >
      <template v-slot:item.sn="{ index }">
        <span>{{ index + 1 }}</span>
      </template>
      <template v-slot:item.score="{ item }">
        <span>{{ Number(item.score || 0).toFixed(2) }}%</span>
      </template>
    </v-data-table>
  </Fragment>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { Q_GET_LEASTPERFORMERS} from '@/gql/command'

  export default {
    name: 'LeastPerformers',
    data: () => ({
      headers: [
        { name: 'sn', value: 'sn' },
        { text: 'Name', value: 'name', width: '100px' },
        { text: 'Score (%)', value: 'score', width: '50px' },

      ],
      thresholdScore: 60,
      limit: 20,
    }),
    computed: {
      ...mapState('records', ['view', 'currentDate', 'startDate', 'endDate']),
      ...mapGetters([
        'team',
      ]),
    },
    apollo: {
      leastPerformers: {
        query: Q_GET_LEASTPERFORMERS,
        variables () {
          return {
            startDate: this.startDate,
            endDate: this.endDate,
            currentTeam: this.team,
            limit: this.limit,
            thresholdScore: this.thresholdScore,
          }
        },
      },
    },
  }
</script>

<style scoped>

</style>
